import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { apiClient } from '@utils';

export const useDeleteGoodLocation = (declarantId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (locationId: string) => {
      const result = await apiClient.declarant.deleteGoodLocation.mutation({ params: { declarantId, locationId } });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['good-locations', declarantId] });
      toast.success('Location of goods deleted successfully');
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.message || 'Failed to delete location of goods');
    },
  });
};
